<template>
  <div class="layout-dropdown-menu">
    <ul class="dropdown-menu-links">
      <li v-for="link in links" @mouseover=openContent(link) @mouseleave="closeContent(link)">
        {{link}}

        <div class="dropdown-menu-content" :class="{'open': isOpenedContent(link)}">
          <slot :name="link"></slot>
        </div>

      </li>
    </ul>
  </div>
</template>


<script>


  export default {
    props: ['links'],
    data() {
      return {
        openedLinks: [],
      }
    },
    methods: {
      isOpenedContent(link) {
        let index = this.openedLinks.indexOf(link);
        return index >= 0;
      },
      openContent(link) {
        if (!this.isOpenedContent(link)) {
          this.openedLinks.push(link);
        }
      },
      closeContent(link) {
        if (this.isOpenedContent(link)) {
          let index = this.openedLinks.indexOf(link);
          this.openedLinks.splice(index, 1);
        }
      }
    },



  }
</script>



// WEBPACK FOOTER //
// node_modules/redbay-b2b-layout/src/navigation/DropdownMenu.vue